<template>
  <div class="item rounded" :class="value.class">
    <span class="letter rounded">{{ value.letter || "-" }}</span>
    <input
      type="text"
      class="answer"
      v-model="value.guess"
      :readonly="value.canGuess"
    />
    <div class="date shadow rounded">
      <div class="month">{{ moment(value.date, "MMM") }}</div>
      <div class="date-number">{{ moment(value.date, "DD") }}</div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import toLower from "lodash/toLower";
import isObject from "lodash/isObject";
import includes from "lodash/includes";
import upperFirst from "lodash/upperFirst";

export default {
  name: "List",
  props: ["value", "today"],
  data() {
    return {};
  },
  created() {
    if (moment(this.today).isAfter(this.value.date, "day")) {
      if (isObject(this.value.answer)) {
        this.value.guess = this.value.answer[0];
        this.value.canGuess = false;
      } else {
        this.value.guess = this.value.answer;
        this.value.canGuess = true;
      }
    }
    this.matchMaker();
  },
  watch: {
    "value.guess"() {
      this.matchMaker();
    }
  },
  methods: {
    todaysColor() {
      if (moment(this.today).isSame(this.value.date, "day")) {
        this.value.class = "item-blue";
      }
    },
    moment(date, format) {
      if (!format) format = "YYYY-MM-DD";
      if (!date) date = new Date();
      return moment(date).format(format);
    },
    matchMaker() {
      if (isObject(this.value.answer)) {
        if (includes(this.value.answer, upperFirst(this.value.guess))) {
          // Correct
          this.value.class = "item-green";
        } else {
          // In-correct
          this.value.class = "item-red";
          this.todaysColor();
        }
      } else {
        if (toLower(this.value.guess) === toLower(this.value.answer)) {
          // Correct
          this.value.class = "item-green";
        } else {
          // In-correct
          this.value.class = "item-red";
          this.todaysColor();
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.item {
  margin-bottom: 15px;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.35);
  padding: 10px;
  border: 1px solid #ccc;
  position: relative;
  border-bottom: 3px solid;
  border-bottom-color: #f65f53;
}
.date {
  overflow: hidden;
  display: inline-block;
  min-width: 30px;
  text-align: center;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}

.month {
  background-color: #f75f53;
  color: white;
  font-size: 0.6rem;
  text-transform: uppercase;
  transition: all 500ms ease;
}

.date-number {
  font-size: 0.8rem;
}

.item-blue {
  border-bottom-color: #1e89de;
}

.item-green {
  border-bottom-color: #57af4c;
}

.item-blue .month,
.item-blue .letter {
  background-color: #1e89de;
}

.item-green .month,
.item-green .letter {
  background-color: #57af4c;
}

.letter {
  background-color: #f75f53;
  padding: 6px 0;
  display: inline-block;
  font-size: 1.5rem;
  color: white;
  width: 45px;
  text-align: center;
  margin-right: 10px;
  transition: all 500ms ease;
}
.answer {
  border: 0px;
  border-bottom: 1px solid #ccc;
  vertical-align: super;
}
</style>
